import jsonp from './jsonp'
import Utils from '../utils/utils'
import store from '../store'

const HOST = 'https://mgact.api.mgtv.com'

function getCommParams() {
  let ua = navigator.userAgent.toLowerCase()
  let platform = ''

  if (/iphone/.test(ua)) {
    platform = 'iphone'
  } else if (/ipad/.test(ua)) {
    platform = 'ipad'
  } else {
    platform = 'android'
  }
  return {
    did: store.state.devicesInfo.did || '',
    device: store.state.devicesInfo.device || '',
    appVersion: store.state.devicesInfo.appVersion || '',
    osType: store.state.devicesInfo.osType || '',
    platform: platform,
    abroad: 0,
    uuid: store.state.userInfo.uuid || '',
    ticket: store.state.userInfo.ticket || '',
    aid: 635,
  }
}
export default {
  getDeviceAndUserInfo() {
    return Promise.all([this.getDeviceInfo(), this.getUserInfo()])
  },
  getDeviceInfo() {
    return new Promise(resolve => {
      if (Utils.isMGTV()) {
        MgtvApi.getDeviceInfo(data => {
          resolve(JSON.parse(data))
        })
      } else {
        let data = {}
        // if (location.href.indexOf('login') > -1) {
        //   data = deviceInfo
        // }
        resolve(data)
      }
    })
  },

  getUserInfo() {
    return new Promise((resolve, reject) => {
      if (Utils.isMGTV()) {
        MgtvApi.getUserInfo(data => {
          resolve(data ? JSON.parse(data) : {})
        })
      } else {
        let userinfo = {
          uuid: Utils.getCookie('uuid'),
          ticket:
            Utils.getCookie('HDCN') && Utils.getCookie('HDCN').split('-')[0],
          HDCN: Utils.getCookie('HDCN'),
        }
        if (!userinfo.ticket && localStorage.getItem('ticket')) {
          userinfo.uuid = localStorage.getItem('uuid')
          userinfo.ticket = localStorage.getItem('ticket')
        }
        resolve(userinfo)
      }
    })
  },
  //接口示例
  //获取主活动aid以及转盘aid
  getConf(is_preview) {
    return jsonp([HOST, '/activity/conf'], {
      aid: 1,
      is_preview: is_preview,
      ...getCommParams(),
    })
  },

  // 获取OSS 临时token
  getOSSToken() {
    return jsonp(
      ['https://upload-ugc.bz.mgtv.com', '/upload/image/getStsToken'],
      {
        biz: 1,
        num: 1,
        ...getCommParams(),
      }
    )
  },
}
